export const DIR_OPTIONS = ["", "E", "N", "NE", "NW", "S", "SE", "SW", "W"];

export const CITIES = [
  "",
  "Alamo",
  "Donna",
  "Edcouch / Elsa",
  "Edinburg",
  "Harlingen",
  "McAllen",
  "Mission",
  "Palmhurst",
  "Pharr",
  "Rio Grande City",
  "San Juan",
  "Weslaco",
  "__other__",
];

export const COUNTIES = [
  "",
  "Hidalgo",
  "Cameron",
  "Willacy",
  "Starr",
  "Zapata",
  "Webb",
  "Brooks",
  "Kenedy",
  "Jim Hogg",
];

export const BATHS_OPTIONS = [
  "",
  "1/2 Baths",
  "1 Baths",
  "1 1/2 Baths",
  "2 Baths",
  "2 1/2 Baths",
  "3 Baths",
  "3 1/2 Baths",
  "4 Baths",
  "4 1/2 Baths",
  "5 Baths",
  "5 1/2 Baths",
  "6 Baths",
  "6 1/2 Baths",
  "7 Baths",
  "7 1/2 Baths",
  "8 Baths",
  "8 1/2 Baths",
  "9 Baths",
  "9 1/2 Baths",
  "10 Baths",
  "10 1/2 Baths",
  "11 Baths",
  "11 1/2 Baths",
  "12 Baths",
];

export const VACANT_TYPES = [
  "",
  "Residential Single Family",
  "Residential Multi-Family",
  "Improved",
  "Unimproved",
  "Mobile Home Park",
  "Native Brush",
  "Other",
];
